// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1CehS","imageUploader":"EGiftCard_imageUploader__3c4p9"};